(function () {
  try {
    var prefs = JSON.parse(localStorage.getItem('studioforge:a11y-prefs') || '{}');
    var root = document.documentElement;
    var map = {
      easierReading: 'a11y-easier-reading',
      highContrast: 'a11y-high-contrast',
      reduceMotion: 'a11y-reduce-motion',
      strongFocus: 'a11y-strong-focus'
    };
    var anyOn = false;
    for (var k in map) {
      if (prefs[k]) { root.classList.add(map[k]); anyOn = true; }
    }
    if (anyOn) root.classList.add('a11y-enabled');
  } catch (e) {}
})();
